import {
  DayCalendarSkeleton as MuiDayCalendarSkeleton,
  DayCalendarSkeletonProps as MuiDayCalendarSkeletonProps
} from '@mui/x-date-pickers';
import React from 'react';

export type DayCalendarSkeletonProps = MuiDayCalendarSkeletonProps;

export const DayCalendarSkeleton = (props: DayCalendarSkeletonProps) => {
  return <MuiDayCalendarSkeleton {...props} />;
};
